import axios from "axios";
import * as Sentry from "@sentry/browser";

axios.defaults.withCredentials = true;

//const API_ENDPOINT = process.env.VUE_APP_API_BASE_URL;
const API_ENDPOINT =
    process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_ENDPOINT;

const payload = () => {
    return { jsonrpc: "2.0", id: +new Date(), method: "", params: {} };
};

export default {
    SUCCESS: "success",

    _headers(method) {
        return {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            // definisce l'area di accesso
            area: method.includes("Eventi.backend") ? "backend" : "frontend"
        };
    },

    _call(method, params) {
        var options = payload();
        options.method = method;
        options.params = params;
        return new Promise((resolve, reject) => {
            axios
                .post(API_ENDPOINT, options, this._headers(method))
                .then(response => {
                    var result = response.data.result;
                    if (
                        typeof result === "object" &&
                        result !== null &&
                        result.status === this.SUCCESS
                    ) {
                        resolve(result);
                    } else {
                        console.error(
                            "Error calling " + method + " - params:",
                            params,
                            " - ",
                            result
                        );
                        var error = result
                            ? result.status
                            : response.data.error;

                        switch(error) {
                            case "Accesso negato":
                                break;
                            default:
                                Sentry.captureException(new Error("Error calling " + method + ": " + error));
                                break;
                        }
                        reject(error);
                    }
                })
                .catch(error => {
                    Sentry.captureException(error);
                    reject(error);
                });
        });
    },

    checkUser(username) {
        var params = [username];
        return this._call("Eventi.checkUser", params);
    },

    createOrder(userData, shippingData, paymentData, invoiceData) {
        var params = [userData, shippingData, paymentData, invoiceData];
        return this._call("Eventi.createOrder", params);
    },

    cancelOrder(orderId) {
        var params = [orderId];
        return this._call("Eventi.cancelOrder", params);
    },

    getOrderInfo(orderId) {
        var params = [orderId];
        return this._call("Eventi.getOrderInfo", params);
    },

    getCartItems() {
        var params = [];
        return this._call("Eventi.getCartItems", params);
    },

    getCheckoutSummary() {
        var params = [];
        return this._call("Eventi.getCheckoutSummary", params);
    },

    insertUser(
        username,
        password,
        cognome,
        nome,
        indirizzo,
        cap,
        citta,
        provincia,
        nazione,
        tel
    ) {
        var params = [
            username,
            password,
            cognome,
            nome,
            indirizzo,
            cap,
            citta,
            provincia,
            nazione,
            tel
        ];
        return this._call("Eventi.insertUser", params);
    },

    login(username, password) {
        var params = [username, password];
        return this._call("Eventi.login", params);
    },

    resetPassword(username) {
        var params = [username];
        return this._call("Eventi.resetPassword", params);
    },

    // FRONTEND APIs
    validateEmail(eventId, email, acceptTerms) {
        var params = [eventId, email, acceptTerms];
        return this._call("Eventi.validateEmail", params);
    },

    validateEmailAddress(email) {
        var params = [email];
        return this._call("Eventi.validateEmailAddress", params);
    },

    getShopData() {
        var params = [window.location.host];
        return this._call("Eventi.getShopData", params);
    },

    getEventUrlFromCoupon(coupon) {
        var params = [coupon, window.location.host];
        return this._call("Eventi.getEventUrlFromCoupon", params);
    },

    getEventData(url) {
        var params = [url];
        return this._call("Eventi.getEventData", params);
    },

    getEventDataDashboard() {
        var params = [];
        return this._call("Eventi.getEventDataDashboard", params);
    },

    getGalleryData(albumId) {
        var params = [albumId];
        return this._call("Eventi.getGalleryData", params);
    },

    photoFavoriteToggle(photoId) {
        var params = [photoId];
        return this._call("Eventi.photoFavoriteToggle", params);
    },

    getPriceSheetData(photoId) {
        var params = [photoId];
        return this._call("Eventi.getPriceSheetData", params);
    },

    getGalleryFavorites() {
        var params = [];
        return this._call("Eventi.getGalleryFavorites", params);
    },

    addItemToCart(photoId, articleCode, quantity, projectId) {
        var params = [photoId, articleCode, quantity, projectId];
        return this._call("Eventi.addItemToCart", params);
    },

    addAllPhotosToCart(articleCode, quantity, onlyFavorites) {
        var params = [articleCode, quantity, onlyFavorites];
        return this._call("Eventi.addAllPhotosToCart", params);
    },

    removeItemFromCart(photoId, articleCode) {
        var params = [photoId, articleCode];
        return this._call("Eventi.removeItemFromCart", params);
    },

    getEventDataInfo() {
        var params = [];
        return this._call("Eventi.getEventDataInfo", params);
    },

    getOrders() {
        var params = [];
        return this._call("Eventi.getOrders", params);
    },

    getItalyProvinces() {
        var params = [];
        return this._call("Eventi.getItalyProvinces", params);
    },

    getItalyCities(province) {
        var params = [province];
        return this._call("Eventi.getItalyCities", params);
    },

    getAccountProfile() {
        var params = [];
        return this._call("Eventi.getAccountProfile", params);
    },

    updateUser(userData) {
        var params = [userData];
        return this._call("Eventi.updateUser", params);
    },

    completeAgentProfile(fkUtenteAgente, profileData) {
        var params = [fkUtenteAgente, profileData];
        return this._call("Eventi.completeAgentProfile", params)
    },

    activateAccount(activationKey) {
        var params = [activationKey];
        return this._call("Eventi.activateAccount", params)
    },

    getEventEmailData(idEventiEmail) {
        var params = [idEventiEmail];
        return this._call("Eventi.getEventEmailData", params);
    },

    disableEventEmail(idEventiEmail) {
        var params = [idEventiEmail];
        return this._call("Eventi.disableEventEmail", params);
    },

    disableAccessNotification(idEventiEmail) {
        var params = [idEventiEmail];
        return this._call("Eventi.disableAccessNotification", params);
    },

    getOpenProjectUrl(projectId) {
        var params = [projectId];
        return this._call("Eventi.getOpenProjectUrl", params);
    },

    getUserInvoiceData() {
        var params = [];
        return this._call("Eventi.getUserInvoiceData", params);
    },

    // BACKEND APIs
    backendLogin(username, password, rememberMe) {
        var params = [username, password, rememberMe];
        return this._call("Eventi.backendLogin", params);
    },

    backendAssignStoreName(username, password, storename) {
        var params = [username, password, storename];
        return this._call("Eventi.backendAssignStoreName", params);
    },

    backendGetFrontendToken(eventId) {
        var params = [eventId];
        return this._call("Eventi.backendGetFrontendToken", params);
    },

    backendGetUserState() {
        var params = [];
        return this._call("Eventi.backendGetUserState", params)
    },

    backendGetDashboard() {
        var params = [];
        return this._call("Eventi.backendGetDashboard", params);
    },

    backendCreateEvent(eventData) {
        var params = [eventData];
        return this._call("Eventi.backendCreateEvent", params);
    },

    backendGetGalleryData(eventId) {
        var params = [eventId];
        return this._call("Eventi.backendGetGalleryData", params);
    },

    backendSaveGalleryPhotos(eventId, photos) {
        var params = [eventId, photos];
        return this._call("Eventi.backendSaveGalleryPhotos", params);
    },

    backendRemoveGalleryPhotos(eventId, photosList) {
        var params = [eventId, photosList];
        return this._call("Eventi.backendRemoveGalleryPhotos", params);
    },

    backendSetGalleryCover(eventId, photoId) {
        var params = [eventId, photoId];
        return this._call("Eventi.backendSetGalleryCover", params);
    },

    backendGetEventData(eventId) {
        var params = [eventId];
        return this._call("Eventi.backendGetEventData", params);
    },

    backendShareEvent(eventId, recipient, subject, content) {
        var params = [eventId, recipient, subject, content];
        return this._call("Eventi.backendShareEvent", params);
    },

    backendGetEventsData() {
        var params = [];
        return this._call("Eventi.backendGetEventsData", params);
    },

    backendGetPricelists() {
        var params = [];
        return this._call("Eventi.backendGetPricelists", params);
    },

    backendCreatePricelist(pricelist) {
        var params = [pricelist];
        return this._call("Eventi.backendCreatePricelist", params);
    },

    backendDeletePricelist(pricelistId) {
        var params = [pricelistId];
        return this._call("Eventi.backendDeletePricelist", params);
    },

    backendGetPricelist(pricelistId) {
        var params = [pricelistId];
        return this._call("Eventi.backendGetPricelist", params);
    },

    backendSavePricelist(pricelist) {
        var params = [pricelist];
        return this._call("Eventi.backendSavePricelist", params);
    },

    backendCreatePricelistCategory(pricelistId, category) {
        var params = [pricelistId, category];
        return this._call("Eventi.backendCreatePricelistCategory", params);
    },

    backendDeletePricelistCategory(pricelistId, categoryId) {
        var params = [pricelistId, categoryId];
        return this._call("Eventi.backendDeletePricelistCategory", params);
    },

    backendGetPricelistCategoryArticles(pricelistId, categoryId) {
        var params = [pricelistId, categoryId];
        return this._call("Eventi.backendGetPricelistCategoryArticles", params);
    },

    backendSortPricelistCategoryArticles(pricelistId, categoryId, articles) {
        var params = [pricelistId, categoryId, articles];
        return this._call(
            "Eventi.backendSortPricelistCategoryArticles",
            params
        );
    },

    backendSortPricelistCategories(pricelistId, categories) {
        var params = [pricelistId, categories];
        return this._call("Eventi.backendSortPricelistCategories", params);
    },

    backendSavePricelistCategoryArticles(pricelistId, categoryId, articles) {
        var params = [pricelistId, categoryId, articles];
        return this._call(
            "Eventi.backendSavePricelistCategoryArticles",
            params
        );
    },

    backendSavePricelistTransferts(pricelistId, transferts) {
        var params = [pricelistId, transferts];
        return this._call("Eventi.backendSavePricelistTransferts", params);
    },

    backendGetEventsList() {
        var params = [];
        return this._call("Eventi.backendGetEventsList", params);
    },

    backendUpdateEventsPricelist(pricelistId, eventsList) {
        var params = [pricelistId, eventsList];
        return this._call("Eventi.backendUpdateEventsPricelist", params);
    },

    backendGetOrders() {
        var params = [];
        return this._call("Eventi.backendGetOrders", params);
    },

    backendResetPassword(username) {
        var params = [username];
        return this._call("Eventi.backendResetPassword", params);
    },

    backendGetSettings() {
        var params = [];
        return this._call("Eventi.backendGetSettings", params);
    },

    backendSaveSettings(settings) {
        var params = [settings];
        return this._call("Eventi.backendSaveSettings", params);
    },

    backendGetEventSettings(eventId) {
        var params = [eventId];
        return this._call("Eventi.backendGetEventSettings", params);
    },

    backendSetEventSettings(eventId, eventData) {
        var params = [eventId, eventData];
        return this._call("Eventi.backendSetEventSettings", params);
    },

    backendGetViewersReport() {
        var params = [];
        return this._call("Eventi.backendGetViewersReport", params);
    },

    backendGetViewersReportWithDeletedEvents(foreignCon, viewDeletedEvents) {
        var params = [foreignCon, viewDeletedEvents];
        return this._call("Eventi.backendGetViewersReport", params);
    },

    backendGetEmailsReport() {
        var params = [];
        return this._call("Eventi.backendGetEmailsReport", params);
    },

    backendDeleteEvent(eventId) {
        var params = [eventId];
        return this._call("Eventi.backendDeleteEvent", params);
    },

    backendGetDefaultWatermarkId() {
        var params = [];
        return this._call("Eventi.backendGetDefaultWatermarkId", params);
    },

    backendGetWatermark(idWatermark) {
        var params = [idWatermark];
        return this._call("Eventi.backendGetWatermark", params);
    },

    backendCreateWatermark() {
        var params = [];
        return this._call("Eventi.backendCreateWatermark", params);
    },

    backendSaveWatermark(watermark) {
        var params = [watermark];
        return this._call("Eventi.backendSaveWatermark", params);
    },

    backendSaveWatermarkImage(idWatermark, watermarkImage) {
        var params = [idWatermark, watermarkImage];
        return this._call("Eventi.backendSaveWatermarkImage", params);
    },

    backendGetAccountProfile() {
        var params = [];
        return this._call('Eventi.backendGetAccountProfile', params);
    },

    backendGetItalyProvinces() {
        var params = [];
        return this._call('Eventi.backendGetItalyProvinces', params);
    },

    backendGetItalyCities(province) {
        var params = [province];
        return this._call('Eventi.backendGetItalyCities', params);
    },

    backendUpdateUser(shopData, agentData, uploadingLogo) {
        var params = [shopData, agentData, uploadingLogo];
        return this._call("Eventi.backendUpdateUser", params);
    },

    backendGetAgents() {
        var params = [];
        return this._call("Eventi.backendGetAgents", params);
    },

    backendInsertAgent(email) {
        var params = [email];
        return this._call("Eventi.backendInsertAgent", params);
    },

    backendUpdateAgent(agentData) {
        var params = [agentData];
        return this._call("Eventi.backendUpdateAgent", params);
    },

    backendDeleteAgent(agentData) {
        var params = [agentData];
        return this._call("Eventi.backendDeleteAgent", params);
    },

    backendAssociateAgentToEvent(associateData) {
        var params = [associateData];
        return this._call("Eventi.backendAssociateAgentToEvent", params);
    },

    backendRemoveAssociationAgentToEvent(associateData) {
        var params = [associateData];
        return this._call("Eventi.backendRemoveAssociationAgentToEvent", params);
    },

    backendAcceptGdpr(shopData, hasCustomGDPR) {
        var params = [shopData, hasCustomGDPR];
        return this._call("Eventi.backendAcceptGdpr", params);
    },

    backendGetShopGdpr() {
        var params = [];
        return this._call("Eventi.backendGetShopGdpr", params);
    },

    backendConfirmGdpr() {
        var params = [];
        return this._call("Eventi.backendConfirmGdpr", params);
    },

    backendRemoveGdpr() {
        var params = [];
        return this._call("Eventi.backendRemoveGdpr", params);
    },

    backendCustomGdprRequest(message) {
        var params = [message];
        return this._call("Eventi.backendCustomGdprRequest", params);
    },

    backendContactCheckPiva(piva) {
        var params = [piva];
        return this._call("Eventi.backendContactCheckPiva", params);
    },

    backendContactRequest(idUtente, shop) {
        var params = [idUtente, shop];
        return this._call("Eventi.backendContactRequest", params);
    },

    backendGetFavorites(eventId, email) {
        var params = [eventId, email];
        return this._call("Eventi.backendGetFavorites", params);
    },

    getCoordinatesFromAddress(shopData) {
        var params = [shopData];
        return this._call("Eventi.getCoordinatesFromAddress", params);
    },

    backendForceActivateAccountByOrderId(orderId) {
        var params = [orderId];
        return this._call("Eventi.backendForceActivateAccountByOrderId", params)
    },

    backendGetProductCategorizations(rapporto) {
        var params = [rapporto];
        return this._call("Eventi.backendGetProductCategorizations", params);
    },

    backendRemoveProjectShare(eventId, projectId) {
        var params = [eventId, projectId];
        return this._call("Eventi.backendRemoveProjectShare", params);
    },

    backendGetShareableProjects(filters) {
        var params = [filters];
        return this._call("Eventi.backendGetShareableProjects", params);
    },

    backendSaveProjectSharePreview(data) {
        var params = [data];
        return this._call("Eventi.backendSaveProjectSharePreview", params);
    },

    backendSaveProjectShare(data) {
        var params = [data];
        return this._call("Eventi.backendSaveProjectShare", params);
    },

    backendDownloadFavorites(eventId, email, format, extension) {
        var params = [eventId, email, format, extension];
        return this._call("Eventi.backendDownloadFavorites", params);
    },

    backendGetInvoices() {
        var params = [];
        return this._call("Eventi.backendGetInvoices", params);
    },

    backendMarkInvoiceAsIssued(invoiceId) {
        var params = [invoiceId];
        return this._call("Eventi.backendMarkInvoiceAsIssued", params);
    },

    backendGetImageData(imageId) {
        var params = [imageId];
        return this._call("Eventi.backendGetImageData", params);
    },

    backendSaveCustomizableProductPreview(data) {
        var params = [data];
        return this._call("Eventi.backendSaveCustomizableProductPreview", params);
    },

    customizableProductCreateProject(productId, themeUrl, title, imagesList) {
        var params = [productId, themeUrl, title, imagesList];
        return this._call("Eventi.customizableProductCreateProject", params);
    },

    bankendGetEC2UploaderURL() {
        var params = [];
        return this._call("Eventi.bankendGetEC2UploaderURL", params);
    }
};
